import React from 'react';
import AboutOcpfView from './components/AboutOCPF';
import MessageView from './components/Message';
import ContactUsView from './components/ContactUs';
import BankSupportView from './components/BankSupport';
import CareerView from './components/JobPostings';
import AccessibilityStatement from './components/AccessibilityStatement';

const routes = [
  {
    path: '/About/AboutOcpf',
    renderer: (params = {}): JSX.Element => <AboutOcpfView {...params} />,
  },
  {
    path: '/Home/AboutOcpf',
    renderer: (params = {}): JSX.Element => <AboutOcpfView {...params} />,
  },
  {
    path: '/About/Message',
    renderer: (params = {}): JSX.Element => <MessageView {...params} />,
  },
  {
    path: '/Home/Message',
    renderer: (params = {}): JSX.Element => <MessageView {...params} />,
  },
  {
    path: '/About/ContactUs',
    renderer: (params = {}): JSX.Element => <ContactUsView {...params} />,
  },
  {
    path: '/Home/ContactUs',
    renderer: (params = {}): JSX.Element => <ContactUsView {...params} />,
  },
  {
    path: '/About/JobPostings',
    renderer: (params = {}): JSX.Element => <CareerView {...params} />,
  },
  {
    path: '/Home/JobPostings',
    renderer: (params = {}): JSX.Element => <CareerView {...params} />,
  },
  {
    path: '/About/BankSupport',
    renderer: (params = {}): JSX.Element => <BankSupportView {...params} />,
  },
  {
    path: '/Home/BankSupport',
    renderer: (params = {}): JSX.Element => <BankSupportView {...params} />,
  },
  {
    path: '/About/AccessibilityStatement',
    renderer: (params = {}): JSX.Element => <AccessibilityStatement {...params} />,
  }
];

export default routes;
